import { AuthorizationRequest } from '../../types/AuthorizationRequest';

import { BannerProps } from './BannerProps';

export const defaultAuthorizationRequest: AuthorizationRequest = {
  clientId: 1,
  redirectUri: 'https://stg-knowledge.smsc-nsc.com',
  state: 'state',
  nonce: 'nonce',
};

export const defaultUpperBannerList: BannerProps[] = [
  {
    id: 1,
    bannerUrl:
      'https://cdn-knowledge-assets.nurse-senka.jp/wp-content/uploads/2020/12/24042539/logo_tiara_web-4.png',
    contentUrl: 'https://knowledge.nurse-senka.jp/tiara_web',
    altText: '看護情報誌ティアラWeb特集',
  },
  {
    id: 2,
    bannerUrl:
      'https://cdn-knowledge-assets.nurse-senka.jp/wp-content/uploads/2021/05/20175429/kisokango_br.jpg',
    contentUrl: 'https://knowledge.nurse-senka.jp/basic_nursing?br',
    altText: '基礎看護技術',
  },
];

export const defaultBottomBannerList: BannerProps[] = [
  {
    id: 10,
    bannerUrl:
      'https://cdn-knowledge-assets.nurse-senka.jp/wp-content/uploads/2021/04/30100943/img_header-min.png',
    contentUrl: 'https://knowledge.nurse-senka.jp/lp_houkan',
    altText: '働き方から、病棟との違いまで　訪問看護師丸わかりガイド',
  },
  {
    id: 11,
    bannerUrl:
      'https://cdn-knowledge-assets.nurse-senka.jp/wp-content/uploads/2021/06/17175117/sangyo.png',
    contentUrl: 'https://square.nurse-senka.jp/articles/150002578?ref=bnr',
    altText: '特集！産業看護職の仕事',
  },
];
